import React from 'react'
import morgenstemning from '../cmap/morgenstemning.json'
import isolum from '../cmap/isolum.json'


class SmlmPreview extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            FileHeader: [],
            FileData:[],
            FileName:'',
            update:false,
            xid: 1, yid: 2, zid: 3, fid: 0 // fid : frame id
        }
        this.mouseDown = false
        this.fovxnm = 0
        this.fovynm = 0
        this.fovznm = 0
        this.fovxnmFilt = 0
        this.fovynmFilt = 0
        this.fovznmFilt = 0
        this.xnmFilt = []
        this.ynmFilt = []
        this.znmFilt = []
        this.cFactor = [1,1,1]
        this.bilinearHistogram = true;
        this.psXY = 10 // 10 nm is default pixel size
        this.psZ = 50 // sampling step for z-color coding
        this.A = 1 // brightness multiplication
        this.zmin = Number.MAX_SAFE_INTEGER
        this.zmax = 0 
        this.xmin = Number.MAX_SAFE_INTEGER
        this.xmax = 0
        this.ymin = Number.MAX_SAFE_INTEGER
        this.ymax = 0
        
        // input field of view
        this.zminFilt = NaN
        this.zmaxFilt = NaN
        this.xminFilt = NaN 
        this.xmaxFilt = NaN
        this.yminFilt = NaN
        this.ymaxFilt = NaN
        this.fovFilt = NaN
        // actual field of view after checks
        this.zminFiltNm = NaN
        this.zmaxFiltNm = NaN
        this.xminFiltNm = NaN 
        this.xmaxFiltNm = NaN
        this.yminFiltNm = NaN
        this.ymaxFiltNm = NaN

        this.timeout=null

        this.onChange.bind(this)
        this.updatePlot.bind(this)
        this.filterData.bind(this)
        this.getMaxProj.bind(this)
        this.computeFOV.bind(this)
        this.doDelayedUpdate.bind(this)
        this.parseConversionFactor.bind(this)
    }
    
    onChange(e) {

        let files = e.target.files;
        let reader = new FileReader();
        let csv_sep = document.getElementById("csv_sep").value;
        reader.readAsText(files[0]);
        
        //once data is loaded
        reader.onload= (e)=> {
            let allText = e.target.result;
            var allTextLines = allText.split(/\r\n|\n/);
            var headers = allTextLines[0].split(csv_sep);

            if (headers.length === 1)
                return

            var lines = [];
        
            for (var i=1; i<Math.min(allTextLines.length,800000); i++) {
                var data = allTextLines[i].split(csv_sep);
                if (data.length === headers.length) {
                    var tarr = [];
                    for (var j=0; j<headers.length; j++) {
                        tarr.push(data[j]);
                    }
                    lines.push(tarr);
                }
            }
            // try to guess which header for each axis
            let xid = -1; let yid = -1; let zid = -1; let fid = -1
            if (isNaN(parseFloat(headers[0]))) { // if header is not a number
                headers.forEach((h,i) => {
                    h = h.toUpperCase()
                    if (h[0] === 'X' & xid === -1)
                        xid = i
                    if (h[0] === 'Y' & yid === -1)
                        yid = i
                    if (h[0] === 'Z' & zid === -1)
                        zid = i
                })
            }
            else
                headers = headers.map((h,i) => "Col. # " + i.toString())
            if (fid === -1) fid = 0
            if (xid === -1) xid = 1
            if (yid === -1) yid = xid+1
            if (zid === -1) zid = yid+1
            // reset FOV settings
            this.psXY = 10;
            this.psZ = 50;
            this.zmin = Number.MAX_SAFE_INTEGER
            this.zmax = 0 
            this.xmin = Number.MAX_SAFE_INTEGER
            this.xmax = 0
            this.ymin = Number.MAX_SAFE_INTEGER
            this.ymax = 0
            
            // input field of view
            this.zminFilt = NaN
            this.zmaxFilt = NaN
            this.xminFilt = NaN 
            this.xmaxFilt = NaN
            this.yminFilt = NaN
            this.ymaxFilt = NaN
            this.fovFilt = NaN
            // actual field of view after checks
            this.zminFiltNm = NaN
            this.zmaxFiltNm = NaN
            this.xminFiltNm = NaN 
            this.xmaxFiltNm = NaN
            this.yminFiltNm = NaN
            this.ymaxFiltNm = NaN
            // setState will trigger the re-rendering
            this.setState({
                FileHeader: headers,
                FileData: lines,
                FileName: files[0]['name'],
                xid: xid,
                yid: yid,
                zid: zid,
                fid: fid
            })
            // loading is done => display the full page
            document.getElementById("parameter-container").style={display:"flex"}
            if (headers.length > 0)
                this.updatePlot()
        }
    }

    updatePlot() {

        // grab data in nm
        this.ynm = new Array(this.state.FileData.length); this.znm= new Array(this.state.FileData.length)
        this.xnm = this.state.FileData.map((l,i) => {
            this.ynm[i] = parseFloat(l[this.state.yid])/this.cFactor[1]
            this.znm[i] = parseFloat(l[this.state.zid])/this.cFactor[2]
            return parseFloat(l[this.state.xid])/this.cFactor[0]
        })
        
        // compute image field of view
        this.xnm.forEach((x,i) => {
            if (x < this.xmin) this.xmin = x
            if (x > this.xmax) this.xmax = x
            if (this.ynm[i] < this.ymin) this.ymin = this.ynm[i]
            if (this.ynm[i] > this.ymax) this.ymax = this.ynm[i]
            if (this.znm[i] < this.zmin) this.zmin = this.znm[i]
            if (this.znm[i] > this.zmax) this.zmax = this.znm[i]
        })

        this.fovxnm = this.xmax-this.xmin 
        this.fovynm = this.ymax-this.ymin 
        this.fovznm = this.zmax-this.zmin
        this.psXY = 10
        this.psZ = 50

        document.getElementById("xmin").value = this.xmin.toString()
        document.getElementById("ymin").value = this.ymin.toString()
        document.getElementById("fov").value = this.fovxnm.toString()
        document.getElementById("zmin").value = this.zmin.toString()
        document.getElementById("zmax").value = this.zmax.toString()

    this.filterData()
    
    }

    filterData() {
        // define bounding boxes based on input FOV if number is provided
        this.xminFiltNm = isNaN(this.xminFilt) ? this.xmin : this.xminFilt
        this.xmaxFiltNm = isNaN(this.xmaxFilt) ? this.xmax : this.xmaxFilt
        this.yminFiltNm = isNaN(this.yminFilt) ? this.ymin : this.yminFilt
        this.ymaxFiltNm = isNaN(this.ymaxFilt) ? this.ymax : this.ymaxFilt
        
        this.fovxnmFilt = this.xmaxFiltNm - this.xminFiltNm
        this.fovynmFilt = this.ymaxFiltNm - this.yminFiltNm

        // this.fovxnm is NaN if the user clicked on the image 
        if (isNaN(this.fovxnm))
            this.fovxnm = Math.min(this.fovxnmFilt,this.fovynmFilt)
        
        if (this.fovxnm < 1000) // FOV never smaller than 1 microns
            this.fovxnm = 1000

        this.xmaxFiltNm = this.xminFiltNm + this.fovxnm
        this.ymaxFiltNm = this.yminFiltNm + this.fovxnm


        document.getElementById("xmin").value = this.xminFiltNm.toString()
        document.getElementById("ymin").value = this.yminFiltNm.toString()
        document.getElementById("fov").value = this.fovxnm.toString()


        // filtering in z
        this.zminFiltNm = isNaN(this.zminFilt) ? this.zmin : this.zminFilt
        this.zmaxFiltNm = isNaN(this.zmaxFilt) ? this.zmax : this.zmaxFilt
        if (this.zmaxFiltNm-this.zminFiltNm < 10){ // less than 10 nm field of view
            let tmp = this.zminFiltNm
            this.zminFiltNm = Math.min(...[this.zminFiltNm,this.zmaxFiltNm]) - 5
            this.zmaxFiltNm = Math.min(...[tmp,this.zmaxFiltNm]) + 5
        }


        // actual filtering 
        var nanmask = new Array(this.xnm.length)
        this.xnm.forEach((x,i) => {
            if ((isNaN(x) | isNaN(this.ynm[i]))) {
                nanmask[i] = false
            }
            else if ( x > this.xmaxFiltNm | x < this.xminFiltNm | this.ynm[i] > this.ymaxFiltNm | this.ynm[i] < this.yminFiltNm) {
                nanmask[i] = false
            }
            else if ( isNaN(this.znm[i]) & (parseFloat(this.state.zid) !== this.state.FileHeader.length)) {
                nanmask[i] = false
            }
            else if ((parseFloat(this.state.zid) !== this.state.FileHeader.length) & (this.znm[i] > this.zmaxFiltNm | this.znm[i] < this.zminFiltNm)){
                nanmask[i] = false 
            }
            else
                nanmask[i] = true
        })
        
        this.xnmFilt = this.xnm.filter((x,i) => nanmask[i])
        this.ynmFilt = this.ynm.filter((y,i) => nanmask[i])
        this.znmFilt = this.znm.filter((z,i) => nanmask[i])

        if (this.xnmFilt.length === 0) // all localizations have been filtered out
            alert("All localizations will be filtered out by the FOV settings!\n"+
                  "Nothing to render, reverting to last settings.")
        else {
            // make sure that the full colormap zrange is used
            this.localzmin = 1000000
            this.localzmax = -1000000
            this.znmFilt.forEach(z => {
                if (z < this.localzmin) this.localzmin = z
                if (z > this.localzmax) this.localzmax = z
            })
            this.zminFiltNm = this.localzmin > this.zminFiltNm ? this.localzmin : this.zminFiltNm 
            this.zmaxFiltNm = this.localzmax < this.zmaxFiltNm ? this.localzmax : this.zmaxFiltNm 
            document.getElementById("zmin").value = this.zminFiltNm.toString()
            document.getElementById("zmax").value = this.zmaxFiltNm.toString()
            this.computeFOV()
        }
    }

    computeFOV(){

        this.fovxnmFilt = this.xmaxFiltNm-this.xminFiltNm
        this.fovynmFilt = this.ymaxFiltNm-this.yminFiltNm
        this.fovznmFilt = this.zmaxFiltNm-this.zminFiltNm
        
        // compute safe number of pixel
        this.sx = Math.ceil(this.fovxnmFilt/this.psXY)
        // max 1500 pixels
        if (this.sx > 1500) this.sx = 1500
        this.psXY = Math.round(this.fovxnmFilt/this.sx)
        document.getElementById("psXY").value = this.psXY.toString().substring(0,4)


        this.sy = Math.ceil(this.fovynmFilt/this.psXY)

        // if zid is the length of the header => it must be "-" i.e. no z
        if (parseFloat(this.state.zid) === this.state.FileHeader.length)
            this.sz = 1
        else
            this.sz = Math.ceil(this.fovznmFilt/this.psZ)
        
        if (this.sz > 30) this.sz = 30
        if (this.sz <= 0) this.sz = 1

        this.psZ = this.fovznmFilt/this.sz

        // from nm to image space 
        this.xImg = this.xnmFilt.map(x => ((x-this.xminFiltNm)/(this.fovxnmFilt )*(this.sx-1)))
        this.yImg = this.ynmFilt.map(y => ((y-this.yminFiltNm)/(this.fovynmFilt )*(this.sy-1)))
        this.zImg = this.znmFilt.map(z => {
            if (this.sz > 1)
                return ((z-this.zminFiltNm)/(this.fovznmFilt)*(this.sz-1))
            else
                return 0
        })
        // floored histogram
        this.xImgFloored = this.xImg.map(x => Math.floor(x))
        this.yImgFloored = this.yImg.map(y => Math.floor(y))
        this.zImgFloored = this.zImg.map(z => Math.floor(z))

        this.getMaxProj()
    }

    getMaxProj(){

        // create and initialize new Array
        var img = new Array(this.sx*this.sy*this.sz)
        for(var i = 0; i < img.length; i++)
            img[i] = 0;

        if (this.bilinearHistogram === false)
            this.xImgFloored.forEach((x,j) => {// floored histogram rendering
            img[(this.yImgFloored[j]*this.sx*this.sz + x*this.sz + this.zImgFloored[j])] += 1;
            
            })
        else
            this.xImgFloored.forEach((x,j) => {// bilinear histogram
                let wx = this.xImg[j]-x
                let wy = this.yImg[j]-this.yImgFloored[j]
                img[(this.yImgFloored[j]*this.sx*this.sz + x*this.sz + this.zImgFloored[j])] += (1-wx)*(1-wy);
                img[(this.yImgFloored[j]*this.sx*this.sz + (x+1)*this.sz + this.zImgFloored[j])] += wx*(1-wy);
                img[((this.yImgFloored[j]+1)*this.sx*this.sz + x*this.sz + this.zImgFloored[j])] += (1-wx)*wy;
                img[((this.yImgFloored[j]+1)*this.sx*this.sz + (x+1)*this.sz + this.zImgFloored[j])] += wx*wy;
                
            })

        // compute maximum projection
        let img2d = new Array(this.sx*this.sy)
        let zindexmap = new Array(this.sx*this.sy)
        for(var i = 0; i < img2d.length; i++){
            let zprofile = img.slice(i*this.sz,(i+1)*this.sz)
            let maxval = 0; let maxind = -1;
            zprofile.forEach( (zp,j) => {
                if (zp >= maxval){
                    maxval = zp
                    maxind = j
                }
            })
            zindexmap[i] = maxind
            img2d[i] = maxval
        }
        
        // normalize brightness
        let imgMax = 0; let zindexmax= 0;
        img2d.forEach(i => {
            if (i > imgMax)
                imgMax = i
            if (zindexmap[i] > zindexmax)
                zindexmax = zindexmap[i]
        })
        if (imgMax === 0)
            imgMax = 1
        if (zindexmax === 0)
            zindexmax = 1

        // grab canvas element
        var c = document.getElementById("myCanvas")
        c.width = this.sx; c.height = this.sy
        let ctx = c.getContext("2d")
        let cmap = isolum;
        let cmapL = cmap.length-1

        var imgData = ctx.createImageData(this.sx,this.sy)
        if (this.sz > 1)
            for(var i = 0; i < img2d.length; i++){
                let index = i*4;
                try{
                imgData.data[index+0] = this.A*img2d[i]*cmap[Math.floor(cmapL*zindexmap[i]/zindexmax)][0]/imgMax //RGBA
                imgData.data[index+1] = this.A*img2d[i]*cmap[Math.floor(cmapL*zindexmap[i]/zindexmax)][1]/imgMax
                imgData.data[index+2] = this.A*img2d[i]*cmap[Math.floor(cmapL*zindexmap[i]/zindexmax)][2]/imgMax 
                imgData.data[index+3] = 255;
                }
                catch {
                    console.log("catch")
                    console.log(Math.floor(cmapL*zindexmap[i]/zindexmax))
                    console.log(cmap.length())
                    console.log(zindexmax)
                    console.log(imgMax)
                }
            }
        else {
            let cmapL = morgenstemning.length-1
            for (i = 0; i < img2d.length; i++){
                let index = i*4;
                let tmp = Math.floor(this.A*cmapL*img2d[i]/imgMax)
                if (tmp > cmapL)
                    tmp = cmapL
                imgData.data[index+0] = morgenstemning[tmp][0] //RGBA
                imgData.data[index+1] = morgenstemning[tmp][1] 
                imgData.data[index+2] = morgenstemning[tmp][2] 
                imgData.data[index+3] = 255;
            }
        }
        
        ctx.putImageData(imgData,0,0,0,0,1100,1100);

        //update page
        this.setState({update:!this.state.update})
    }

    doDelayedUpdate(str,obj) {

            if( this.timeout)
                clearTimeout(this.timeout);
            
            if (obj === "zmin" | obj === "zmax" | obj === "xmin" | obj === "fov" | obj === "ymin")
                this.timeout = setTimeout(() => this.filterData(), 1000);
            else if (obj === "psXY") {
                let val = parseFloat(str)
                if (!isNaN(val))
                    this.timeout = setTimeout(() => this.computeFOV(),1000)
            }
            else if (obj === "brightness") {
                let val = parseFloat(str)
                if (!isNaN(val)){
                    this.timeout = setTimeout(() => this.getMaxProj(), 1000);
            }            
        }
    }

    parseConversionFactor = (str) => {
        let tmp = str.split(',')
        tmp = tmp.filter((t) => t.length > 0)
        if (tmp.length === 1)
            tmp = [parseFloat(tmp[0]),parseFloat(tmp[0]),parseFloat(tmp[0])]
        else if (tmp.length === 2)
            tmp =  [parseFloat(tmp[0]),parseFloat(tmp[0]),parseFloat(tmp[1])]
        else
            tmp =  [parseFloat(tmp[0]),parseFloat(tmp[1]),parseFloat(tmp[2])]
        return tmp
    }

    render () {
        return (
            <div>
                <h1>Online SMLM bilinear rendering</h1>
                <div style={{display:"flex"}}>
                    <div className="upload" style={{width:"100%"}}>
                        <input type="file" name="upload-input" className="upload-input" id="upload-input" onChange={(e) => this.onChange(e)}/>
                        <label htmlFor="upload-input" className="btn btn-secondary btn-sm icon-right">
                            Choose a csv localization file
                            <svg className="icon" aria-hidden="true">
                            <use xlinkHref="#icon-upload"></use>
                            </svg>
                        </label>
                        <span className="upload-preview" style={{fontSize:"16px",marginLeft:"5px"}}>
                            {this.state.FileName.length > 0 ?
                                this.state.FileName
                                : 'No file'
                            }
                        </span>
                        <div style={{display:"flex"}}>
                            <span className="form-group">
                                <label>Select csv separator</label>
                                <select  id="csv_sep" className="custom-select">
                                    <option value={","} key={0}>Comma</option>
                                    <option value={";"} key={1}>Semicolon</option>
                                    <option value={"\t"} key={2}>Tab</option>
                                </select>
                            </span>
                        </div>
                    </div>
                </div>
                {<div id="parameter-container" style={{display:"none"}}>
                    <div style={{display:"flex",margin:"10px"}}>
                    <span className="form-group">
                            <label>Select header for x location</label>
                            <select id="xid" className="custom-select" value ={this.state.xid}
                                onChange={() => {this.state.xid = document.getElementById("xid").value
                                    this.updatePlot()}}>
                                {this.state['FileHeader'].map((h,i) => {
                                    return (<option value={i} key={i}>{h}</option>)
                                })
                                }
                            </select>
                        </span>
                        <span className="form-group">
                            <label>Select header for y location</label>
                            <select id="yid" className="custom-select" value ={this.state.yid}
                                onChange={() => {this.state.yid = document.getElementById("yid").value
                                    this.updatePlot()}}>
                                {this.state['FileHeader'].map((h,i) => {
                                    return (<option value={i} key={i}>{h}</option>)
                                })
                                }
                            </select>
                        </span>
                        <span className="form-group">
                            <label>Select header for z location (select "-" for 2D data)</label>
                            <select id="zid" className="custom-select" value ={this.state.zid}
                                onChange={() => {this.state.zid = document.getElementById("zid").value
                                    this.updatePlot()}}>
                                {this.state['FileHeader'].map((h,i) => {
                                    return (<option value={i} key={i}>{h}</option>)
                                })
                                }
                                <option value={this.state.FileHeader.length} key={this.state.FileHeader.length}>-</option>
                            </select>
                        </span>
                    </div>
                    <div className="form-group">
                        <label htmlFor="awesome-input">Conversion factor [localization units/nm]</label>
                        <input type="text" id="cFactor" className="form-control" placeholder="1,1,1" aria-describedby="awesome-input-help"
                            onChange={()=> {
                                this.cFactor = this.parseConversionFactor(document.getElementById("cFactor").value)
                                this.doDelayedUpdate(this.cFactor,"cFactor");
                            }}/>
                        <small id="awesome-input-help" className="form-text text-muted">
                            All your localizations will be divided by this number. Provide two numbers (separated by a comma) if the z scale is different. Provide three numbers if x,y and z scales are different.
                            <br></br>Default is 1 (i.e. localizations are already in nm) for all axis
                        </small>
                    </div>
                    <hr></hr>
                    <h5>Data preview: FOV: {(this.fovxnmFilt/1000).toString().substring(0,5)} um x 
                    {(this.fovynmFilt/1000).toString().substring(0,5)} um x 
                    {(this.fovznmFilt/1000).toString().substring(0,5)} um (pixel size: 
                    {this.psXY.toString().substring(0,4)} x {this.psXY.toString().substring(0,4)} x {Math.round(this.psZ)} nm)</h5>
                    <label>Drag your mouse on the image to zoom-in. Shift-click to reset the FOV.</label>
                    <div style={{display:"flex",flexWrap:"wrap"}}>
                        <span style={{margin:"5px"}}>
                            <label htmlFor="awesome-input" style={{marginRight:"5px"}}> Brightness: </label>
                            <input type="text" id="brightness" placeholder={this.A} aria-describedby="awesome-input-help" onChange={() => {
                                this.A = parseFloat(document.getElementById("brightness").value)
                                this.doDelayedUpdate(document.getElementById("brightness").value,"brightness")
                            }}
                                style={{width:"100px"}}/>
                        </span>
                        <span style={{margin:"5px"}}>
                            <label htmlFor="awesome-input" style={{marginRight:"5px"}}> Pixel size: </label>
                            <input type="text" id="psXY" placeholder={this.psXY} aria-describedby="awesome-input-help" onChange={() => {
                                this.psXY = parseFloat(document.getElementById("psXY").value)
                                this.doDelayedUpdate(document.getElementById("psXY").value,"psXY")
                            }}
                                style={{width:"100px"}}/>
                        </span>
                        <span style={{margin:"5px"}}>
                            <label htmlFor="awesome-input" style={{marginRight:"5px"}}> X min: </label>
                            <input type="text" id="xmin" placeholder={this.xmin} aria-describedby="awesome-input-help" onChange={() => {
                                this.xminFilt = parseFloat(document.getElementById("xmin").value)
                                this.doDelayedUpdate(document.getElementById("xmin").value,"xmin")
                            }}
                                style={{width:"100px"}}/>
                        </span>
                        <span style={{margin:"5px"}}>
                            <label htmlFor="awesome-input" style={{marginRight:"5px"}}> Y min: </label>
                            <input type="text" id="ymin" placeholder={this.ymin} aria-describedby="awesome-input-help" onChange={() => {
                                this.yminFilt = parseFloat(document.getElementById("ymin").value)
                                this.doDelayedUpdate(document.getElementById("ymin").value,"ymin")
                            }}
                                style={{width:"100px"}}/>
                        </span>
                        <span style={{margin:"5px"}}>
                            <label htmlFor="awesome-input" style={{marginRight:"5px"}}> FOV: </label>
                            <input type="text" id="fov" placeholder={this.fovxnm} aria-describedby="awesome-input-help" onChange={() => {
                                this.fovxnm = parseFloat(document.getElementById("fov").value)
                                this.doDelayedUpdate(document.getElementById("fov").value,"fov")
                            }}
                                style={{width:"100px"}}/>
                        </span>
                        <span style={{margin:"5px"}}>
                            <label htmlFor="awesome-input" style={{marginRight:"5px"}}> Z min: </label>
                            <input type="text" id="zmin" placeholder={this.zmin} aria-describedby="awesome-input-help" onChange={() => {
                                this.zminFilt = parseFloat(document.getElementById("zmin").value)
                                this.doDelayedUpdate(document.getElementById("zmin").value,"zmin")
                            }}
                                style={{width:"100px"}} />
                        </span>
                        <span style={{margin:"5px"}}>
                            <label htmlFor="awesome-input" style={{marginRight:"5px"}}> Z max: </label>
                            <input type="text" id="zmax" placeholder={this.zmax} aria-describedby="awesome-input-help" onChange={() => {
                                this.zmaxFilt = parseFloat(document.getElementById("zmax").value)
                                this.doDelayedUpdate(document.getElementById("zmax").value,"zmax")
                            }}
                                style={{width:"100px"}} />
                        </span>
                    </div>
                    <div style={{display:"flex"}}>
                        <div>
                            <div style={{margin:"10px"}}>
                                <div width="1100px" height="1100px">
                                    <canvas id="myCanvas" width="1100px" height="1100px" style={{width:"1100px",height:"1100px"}}
                                    
                                    onMouseDown={(e) => {
                                        var rect = e.target.getBoundingClientRect();
                                        
                                        this.xminFilt = e.clientX-rect.left
                                        this.yminFilt = e.clientY-rect.top
                                        this.mouseDown = true
                                        
                                    }}
                                    onMouseMove= {(e)=> {
                                        if (this.mouseDown) {
                                            var roi = document.getElementById("ROI").style
                                            var rect = e.target.getBoundingClientRect()
                                            var w = e.clientX -(this.xminFilt+rect.left)
                                            var h = e.clientY -(this.yminFilt+rect.top)
                                            
                                            roi.left = (w>0) ? (this.xminFilt+rect.left + window.scrollX) + "px":
                                                (this.xminFilt+rect.left + window.scrollX + w) + "px"
                                            
                                            roi.top  = (h>0) ? (this.yminFilt+rect.top  + window.scrollY) + "px":
                                                (this.yminFilt+rect.top  + window.scrollY + h) + "px"

                                            roi.height =  Math.abs(h) + "px"
                                            roi.width =   Math.abs(w) + "px"
                                            roi.display = "block";
                                            
                                        }
                                    }}
                                    onMouseUp={(e) => {
                                        document.getElementById("ROI").style.display="none";
                                        if (this.mouseDown)
                                            if (e.shiftKey) {
                                                this.xminFilt = NaN 
                                                this.xmaxFilt = NaN 
                                                this.yminFilt = NaN 
                                                this.ymaxFilt = NaN 
                                            }
                                            else {
                                                var rect = e.target.getBoundingClientRect();
                                                this.xmaxFilt = e.clientX-rect.left
                                                this.ymaxFilt = e.clientY-rect.top
                                                // convert to nm based on previous FOV
                                                this.xminFilt = ((this.xminFilt/1100)*this.fovxnm) + this.xminFiltNm
                                                this.xmaxFilt = ((this.xmaxFilt/1100)*this.fovxnm) + this.xminFiltNm
                                                this.yminFilt = ((this.yminFilt/1100)*this.fovxnm) + this.yminFiltNm
                                                this.ymaxFilt = ((this.ymaxFilt/1100)*this.fovxnm) + this.yminFiltNm
                                                // sort min-max values
                                                if (this.xminFilt>this.xmaxFilt) {
                                                    let tmp = this.xminFilt
                                                    this.xminFilt = this.xmaxFilt
                                                    this.xmaxFilt = tmp
                                                }
                                                if (this.yminFilt>this.ymaxFilt) {
                                                    let tmp = this.yminFilt
                                                    this.yminFilt = this.ymaxFilt
                                                    this.ymaxFilt = tmp
                                                }
                                            }
                                        this.mouseDown = false
                                        this.fovxnm = NaN
                                        this.filterData()
                                    }} 
                                    onMouseLeave={()=>{
                                        this.mouseDown = false
                                        document.getElementById("ROI").style.display="none";
                                    }}>
                                    </canvas>
                                </div>
                            </div>
                            <div style={{margin:"10px"}}>
                                <div>
                                    <canvas id="canvasXZ" width="0" height="0" style={{width:"0px",height:"0px"}}>
                                    </canvas>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="ROI" style={{position:"absolute",top:"50px",left:"50px",border:"solid",borderWidth:"2px",borderColor:"white",
                        display:"none",zIndex:"50",width:"50px",height:"50px",
                        pointerEvents:"none"}}></div>
                </div>}
            </div>
        )
    }
}


export default SmlmPreview;


